import axios from 'axios'

export const getMarketsByBounds = async (bounds, location, token) => {
  const url = process.env.GATSBY_API_MARKET_SEARCH
  const headers = { Authorization: `Bearer ${token}` }
  const params = {
    op: 'byBounds',
    location: JSON.stringify(location),
    bounds: JSON.stringify(bounds),
    size: 500
  }

  const res = await axios({
    method: 'get',
    url,
    headers,
    params
  })

  const items = res.data.hits.hits.map(hit => hit._source)

  return {
    response: res,
    numberOfItems: res.data.hits.hits.length,
    result: items
  }
}
